import siFetch from "api/fetch";

const balance = (init = null) => siFetch("/api/v1/asset/balance", init);

export default balance;
